import { FC, memo } from 'react';
import { TransactionFilterForm, ITransactionFilterForm } from './TransactionFilterForm';

export const TransactionFilter: FC<ITransactionFilterForm> = memo((props) => (
  <TransactionFilterForm {...props} />
));
